/**
 * BỘ TÀI LIỆU BÁO CÁO & KẾ HOẠCH MẠNG XÃ HỘI (DIGITAL & SOCIAL MEDIA)
 * THÁNG 10/2026 — FIT TOUR: DU LỊCH CÓ GUU
 */

export const BAO_CAO_TIKTOK_T10_MARKDOWN = `# BÁO CÁO KẾ HOẠCH & CHỈ TIÊU TIKTOK STUDIO
## THÁNG 10/2026 — FIT TOUR: DU LỊCH CÓ GUU
**Kênh: @fittour – FIT TOUR - Du lịch có Guu**  
*Thời gian triển khai: 01/10/2026 – 31/10/2026 | Nền tảng: TikTok Studio Creator*

---

### 1. TỔNG QUAN ĐÒN BẨY TỪ THÁNG 9 & MỤC TIÊU KPI THÁNG 10/2026

Tháng 9/2026 đã khép lại với kết quả vượt mục tiêu đề ra trên kênh TikTok Studio:
* **Lượt xem video (Views):** Đạt **22,700 lượt xem** (Đạt **113.5% KPI**, tăng **+12.7%** so với tháng trước).
* **Tương tác:** Đạt **533 lượt thích** (tăng mạnh **+36.7%**), **155 lượt chia sẻ** (+30.3%), **92 bình luận**.
* **Đặc biệt, cơ cấu nguồn truy cập có tính đột phá:**
  * **Đề xuất (FYP):** Chiếm **56.2%** lượng người xem mới.
  * **Tìm kiếm (TikTok Search):** Chiếm tới **32.2%** — chứng minh du khách đang chủ động tìm kiếm các tour du lịch có guu của FIT TOUR trên nền tảng TikTok.

Dựa trên đòn bẩy này, **Kế hoạch Tháng 10/2026** nâng cao chỉ tiêu và tập trung vào **chuyển đổi du khách mùa Thu – Đông**:

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Mục Tiêu Video (KPI)</div>
    <div style="font-size: 34px; font-weight: 800; color: #38bdf8; margin: 8px 0;">30 Video</div>
    <div style="font-size: 12px; color: #94a3b8;">1 video chất lượng/ngày</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Mục Tiêu Lượt Xem</div>
    <div style="font-size: 34px; font-weight: 800; color: #4ade80; margin: 8px 0;">&gt; 30,000</div>
    <div style="font-size: 12px; color: #4ade80;">Tăng +32% so với T9 (22.7K)</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Xem Hồ Sơ (Profile)</div>
    <div style="font-size: 34px; font-weight: 800; color: #fbbf24; margin: 8px 0;">&gt; 800</div>
    <div style="font-size: 12px; color: #fbbf24;">Dẫn dắt tệp khách tiềm năng</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Chuyển Đổi Link Bio</div>
    <div style="font-size: 34px; font-weight: 800; color: #ec4899; margin: 8px 0;">&gt; 50 Leads</div>
    <div style="font-size: 12px; color: #f472b6;">Nhấp Zalo OA / Hotline tư vấn</div>
  </div>
</div>

---

### 2. BẢNG ĐỐI SOÁT CHỈ TIÊU KPI THÁNG 10/2026

| Tiêu Chí Đo Lường | Thực Tế Tháng 09 | Chỉ Tiêu KPI Tháng 10 | Tỷ Lệ Tăng Trưởng | Trọng Tâm Chiến Lược |
| :--- | :---: | :---: | :---: | :--- |
| **Số Lượng Video** | 30 video | **30 video** | Duy trì | 1 video/ngày, độ dài tối ưu 25 – 45 giây |
| **Tổng Lượt Xem (Views)** | 22,700 views | **&gt; 30,000 views** | **+32.2%** | Đẩy mạnh video tuyến mùa Thu - Đông cao điểm |
| **Lượt Thích (Likes)** | 533 likes | **&gt; 800 likes** | **+50.1%** | Tăng góc quay visual mãn nhãn & âm nhạc cảm xúc |
| **Lượt Bình Luận (Comments)** | 92 comments | **&gt; 150 comments** | **+63.0%** | Kêu gọi hành động CTA hỏi lịch trình ở cuối clip |
| **Lượt Chia Sẻ (Shares)** | 155 shares | **&gt; 250 shares** | **+61.3%** | Clip cẩm nang du lịch hữu ích du khách muốn gửi bạn bè |
| **Lượt Xem Hồ Sơ (Profile)** | 633 views | **&gt; 800 views** | **+26.4%** | Tối ưu Bio và ghim video best-seller |
| **Tỷ Lệ Search SEO** | 32.2% | **Duy trì &gt; 30%** | Ổn định | Đặt tiêu đề từ khóa chuẩn SEO du lịch |

---

### 3. BỐN TRỤ CỘT NỘI DUNG TRỌNG TÂM (CONTENT PILLARS) THÁNG 10

Để đạt mục tiêu 30,000 views và tạo ra lead chất lượng, phòng Video Marketing tập trung vào 4 định dạng chủ đạo:

#### 🍂 Trụ cột 1: Tuyến Tour Mùa Vàng & Lá Đỏ (Tỷ trọng 35% – 11 Video)
* **Chủ đề chính:** Cửu Trại Câu thiên đường lá đỏ, Bắc Kinh mùa thu vàng, Nhật Bản mùa phong chuyển màu.
* **Hình thức thể hiện:** Flycam bao quát khung cảnh ngoạn mục, chuyển cảnh mượt theo nhạc ambient, cận cảnh mặt hồ trong vắt.
* **Từ khóa SEO TikTok:** *#cuutraicau #dulichcuutraicau #tourcuutraicau #fittour #ladotrunghoa*

#### 🏔️ Trụ cột 2: Tuyến Độc Bản Tây Tạng & Himalaya (Tỷ trọng 30% – 9 Video)
* **Chủ đề chính:** Ladakh tuyết trắng đầu mùa, Vương quốc Hạnh Phúc Bhutan, Nepal khám phá nóc nhà thế giới.
* **Hình thức thể hiện:** Kể chuyện (Storytelling) về văn hóa Phật giáo Mật tông, tiếng chuông gió tu viện, sự tĩnh lặng của tâm hồn.
* **Từ khóa SEO TikTok:** *#ladakh #dulichladakh #bhutan #taytang #fittourduguu*

#### 💡 Trụ cột 3: Cẩm Nang & Tips Du Lịch Có Guu (Tỷ trọng 20% – 6 Video)
* **Chủ đề chính:** Bí quyết chuẩn bị hành lý đi tour lạnh giá, mẹo chống sốc độ cao (Altitude Sickness), thủ tục visa nhanh, cách chụp ảnh đẹp khi du lịch một mình.
* **Hình thức thể hiện:** Hook mạnh trong 3 giây đầu (VD: *"Đi Cửu Trại Câu mùa này mang thiếu 3 món này là hối hận..."*). Tận dụng tỷ lệ tìm kiếm 32.2%.
* **Từ khóa SEO TikTok:** *#kinhnghiemdulich #meodulich #camnangdulich #fittourtips*

#### 💬 Trụ cột 4: Cảm Nhận Khách Hàng & Hậu Trường Tour (Tỷ trọng 15% – 4 Video)
* **Chủ đề chính:** Cảm xúc du khách khi đứng trước dãy Himalaya, lời cảm ơn trưởng đoàn, dịch vụ chăm sóc chu đáo của FIT TOUR.
* **Hình thức thể hiện:** Phỏng vấn ngắn chân thực (Social Proof) tạo dựng niềm tin tuyệt đối.

---

### 4. KHUNG GIỜ VÀNG & QUY TRÌNH XUẤT BẢN VIDEO

| Khung Giờ | Thời Gian Đăng | Đối Tượng Người Xem Mục Tiêu | Loại Nội Dung Khuyên Dùng |
| :--- | :---: | :--- | :--- |
| **Khung Trưa** | **11:30 – 12:30** | Dân văn phòng, người đi làm thư giãn giờ cơm trưa | Tips du lịch, cẩm nang ngắn, ẩm thực địa phương |
| **Khung Tối (Cao điểm)** | **19:30 – 21:30** | Toàn bộ gia đình, người dùng lướt giải trí buổi tối | Video cảnh sắc điện ảnh, trải nghiệm tour độc bản, flycam |

---

### 5. GIẢI PHÁP TỐI ƯU HÓA CHUYỂN ĐỔI (LEAD GENERATION TỪ TIKTOK)

1. **Chuẩn hóa trang chủ kênh (@fittour):**
   * Ghim 3 video: (1) Phim giới thiệu thương hiệu FIT TOUR – Du lịch có Guu; (2) Tuyến Tour Cửu Trại Câu lá đỏ hot nhất; (3) Cảm nhận khách hàng thực tế.
2. **Khai thác tệp 633+ lượt xem hồ sơ:**
   * Cập nhật Bio: *"FIT TOUR – Chuyên tour độc bản & trải nghiệm có guu. Hotline tư vấn: 0938.xxx.xxx"* kèm link trực tiếp dẫn về Website/Zalo OA.
3. **Chăm sóc tương tác hai chiều:**
   * Trưởng bộ phận Video & CSKH phản hồi 100% bình luận trong vòng **15 phút** sau khi đăng để đẩy video lên xu hướng (FYP).
`;
